<template>
    <div>
      <div class="scroll-mirror" :style="{ top: `${scrollPercentage}%` }">
        <img class="scroll-img" src="images/astro-kitty-jets.png">
      </div>
      <div class="moon-container-scroll">
        <img class="moon-img-scroll" src="images/moon.png">
      </div>
      <div class="earth-container-scroll">
        <img class="earth-img-scroll" src="images/earth.png">
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        scrollPercentage: 0
      };
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll);
    },
    beforeUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      handleScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        
        // Calculate scroll percentage
        const scrollPercentage = (scrollTop / (documentHeight - windowHeight)) * 100;
        
        // Invert the scroll percentage so the mirror moves in the opposite direction
        this.scrollPercentage = 100 - scrollPercentage;
      }
    }
  };
  </script>
  
  <style>
  .scroll-mirror {
    position: fixed;
    left: 20px; /* Adjust position as needed */
    color: white;
    padding: 10px;
    border-radius: 5px;
    z-index: 9999; /* Ensure it's above other content */
  }
  
  .scroll-img {
    height: 100px;
  }
  
  .moon-container-scroll {
    position: fixed;
    top: 20px; /* Adjust position as needed */
    left: 20px; /* Adjust position as needed */
    z-index: -99999;
  }
  
  .moon-img-scroll {
    height: 100px;
  }

  .earth-container-scroll {
    position: fixed;
    bottom: 20px; /* Adjust position as needed */
    left: 20px; /* Adjust position as needed */
    z-index: -99999;
  }
  
  .earth-img-scroll {
    height: 100px;
  }
  </style>
  